import "../style/TutorialPage.css";

export default function TutorialPage({ setPageState }) {

  return (
    <div className="jump-rope-tutorial-page">
      <div className="jump-rope-tutorial-card">
        <h1>Jump Rope Game Tutorial</h1>

        <section className="jump-rope-tutorial-section">
          <h2>How To Play</h2>
          <ul className="jump-rope-tutorial-list">
            <li>1.) An English word will be displayed in an oval at the top, with several Korean character options appearing below</li>
            <li>2.) A moving indicator slides left and right across the characters</li>
            <li>3.) Press the "Jump!" button to stop the indicator</li>
            <li>4.) If the indicator is over the correct Korean translation, the character jumps over the rope!</li>
          </ul>
        </section>

        <section className="jump-rope-tutorial-section">
          <h2>Rules</h2>
          <ul className="jump-rope-tutorial-list">
            <li>1.) You have limited time to make your choice (shown in top right)</li>
            <li>2.) You lose a life for answering incorrectly or running out of time.</li>
            <li>3.) The game ends when you lose all 3 of your lives or answer all the questions.</li>
          </ul>
        </section>
        
        <section className="jump-rope-tutorial-section">
          <h2>Difficulty Levels</h2>
          <ul className="jump-rope-tutorial-list">
            <li>
              <strong>Easy:</strong> 10 seconds per word, 3 options
            </li>
            <li>
              <strong>Medium:</strong> 7 seconds per word, 4 options
            </li>
            <li>
              <strong>Hard:</strong> 5 seconds per word, 5 options
            </li>
          </ul>
        </section>

        <div className="jump-rope-tutorial-actions">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => setPageState("setup")}
          >
            Back to Setup
          </button>
        </div>
      </div>
    </div>
  );
}
